/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {Button} from "react-bootstrap";
import {GuidUtils} from "../../../Utils/GuidUtils";
import {Glyphicon} from "../../../Components/Common/GlyphIcon";
import {SubmissionBoundaryOrderFieldViewer} from "../FieldViewers";
import {BOUNDARY_CODE} from "../../../Hooks/SubmissionBoundaryHooks";

export const SubmissionBoundaryOrderFieldEditor = (props) => {
    const getSurveySecsDef = () => {
        for (const group of props.FieldDefs ?? []) {
            const def = group.value?.find(f => f.key === 'SurveySections');
            if (def) return def;
        }
        return null;
    };

    const addBoundarySection = () => {
        const {Data, OnUpdates} = props;
        const sectionsDef = getSurveySecsDef();
        if (!sectionsDef) return;

        const newSection = {
            _tempId: GuidUtils.Generate(),
            surveyId: Data?.surveyId ?? null,
            surveySectionId: null,
            code: BOUNDARY_CODE,
            name: 'Internal Use Only',
            order: 0,
            deleted: null,
            SurveyQuestions: [],
        };

        OnUpdates([{
            def: sectionsDef,
            value: [newSection, ...(Data?.SurveySections ?? [])],
        }]);

        setTimeout(() => {
            /**
             * @type {HTMLInputElement}
             */
            const nameInput = document.querySelector('.sb-editor-row-name input, .sb-editor-row-name textarea');
            if (nameInput) {
                nameInput.select();
                nameInput.focus();
                nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 0);
    };

    const {Data} = props;
    const boundarySection = (Data?.SurveySections ?? []).find(s => s.code === BOUNDARY_CODE);

    if (boundarySection) {
        return <SubmissionBoundaryOrderFieldViewer
            {...props}
            Value={boundarySection.order}
        />;
    }

    return (
        <Button variant="link" onClick={addBoundarySection}>
            <Glyphicon glyph="plus-sign"/>Add Submission Review Boundary
        </Button>
    );
};
